import { ADD_PRODUCT_TO_CART, UPDATE_PRODUCT_CART } from './type';

// CART
export const addProductToCartStore = (payload) => ({
    type: ADD_PRODUCT_TO_CART,
    payload,
});

export const updateProductCartStore = (payload) => ({
    type: UPDATE_PRODUCT_CART,
    payload,
});
